import { CENTERS } from '../data.js';
import { roomsInCity, totalRoomsLive } from '../state.js';
import { cityMetaLabel, t } from '../i18n.js';
import { setFlaps } from './flap.js';

function cityRows() {
  return Object.keys(CENTERS)
    .map((c) => {
      const rooms = roomsInCity(c);
      return `<button class="citybtn" data-city="${c}">
        <span class="cinfo">
          <span class="cn">${c}</span>
          <span class="cmeta">${cityMetaLabel(c)}</span>
        </span>
        <span class="cstat">
          <span class="ccount">${rooms}</span>
          <span class="cunit">${t('sp.live.unit')}</span>
        </span>
      </button>`;
    })
    .join('');
}

export function buildSplash({ onEnter, onChange }) {
  rebuildCityLists();

  const splashCount = document.getElementById('splashCount');
  if (splashCount) setFlaps(splashCount, String(totalRoomsLive()), false);

  document.getElementById('cityList').addEventListener('click', (e) => {
    const b = e.target.closest('[data-city]');
    if (b) onEnter(b.dataset.city);
  });

  document.getElementById('citySheetList').addEventListener('click', (e) => {
    const b = e.target.closest('[data-city]');
    if (b) onChange(b.dataset.city);
  });

  document.getElementById('detect').addEventListener('click', () => {
    const btn = document.getElementById('detect');
    btn.textContent = t('sp.locating');
    if (!navigator.geolocation) return onEnter('Tashkent');
    navigator.geolocation.getCurrentPosition(
      (p) => {
        let best = 'Tashkent';
        let bd = Infinity;
        for (const [c, [la, ln]] of Object.entries(CENTERS)) {
          const d = (la - p.coords.latitude) ** 2 + (ln - p.coords.longitude) ** 2;
          if (d < bd) {
            bd = d;
            best = c;
          }
        }
        onEnter(best);
      },
      () => onEnter('Tashkent'),
      { timeout: 6000 },
    );
  });
}

export function rebuildCityLists() {
  const list = document.getElementById('cityList');
  const sheet = document.getElementById('citySheetList');
  if (list) list.innerHTML = cityRows();
  if (sheet) sheet.innerHTML = cityRows();
}

export function hideSplash() {
  document.getElementById('splash').classList.add('hide');
}
